import React from 'react';
import './itemList.css';
import itemLogo from '../../assets/icons/icon-gas-truck.svg';
import { formatTime } from '../../utils/generalFunctions';

// Función de formateo para timestamps
const formatDayTime = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
};

const parseDateMinutes = (date) => {
    if (date === 0 || date === null) {
        return 0;
    }
    const [hours, minutes, seconds] = new Date(date).toTimeString().split(' ')[0].split(':');
    return parseInt(hours * 3600 + minutes * 60 + seconds);
}

// Función de contenido común para cada item
const renderDataItem = (value, previousValue, formatter, unit) => (
    <span className={`${value > previousValue ? 'high' : (value < previousValue ? 'low' : 'normal')}`} style={{ textAlign: 'center' }}>
        {formatter(value)} {unit}
    </span>
);

const ItemList = ({ index, type, name, data }) => {
    return (
        <div className='itemTop_container'>
            <span className='itemTop_index'>{index}</span>
            <img src={itemLogo} alt='Ícono del vehículo' className='itemTop_logo' />
            <span className='itemTop_name'>{name}</span>

            {type === 'mileage' && (
                <>
                    <div className='itemTop_data_container'>
                        {renderDataItem((data.currentMileage), (data.previousMileage), val => val, 'km')}
                        {renderDataItem((data.currentTime), (data.previousTime), formatTime)}
                    </div>
                    <div className='itemTop_data_container'>
                        {renderDataItem((data.previousMileage), (data.currentMileage), val => val, 'km')}
                        {renderDataItem((data.previousTime), (data.currentTime), formatTime)}
                    </div>
                </>
            )}

            {type === 'stoppedTime' && (
                <>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.currentIdleDuration, data.previousIdleDuration, formatTime)}
                    </div>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.previousIdleDuration, data.currentIdleDuration, formatTime)}
                    </div>
                </>
            )}

            {type === 'speedViolation' && (
                <>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.currentViolations, data.previousViolations, val => val)}
                    </div>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.previousViolations, data.currentViolations, val => val)}
                    </div>
                </>
            )}

            {type === 'speedViolationMax' && (
                <>
                    <div className='itemTop_data_container many_items'>
                        {renderDataItem(parseInt(data.currentData.max_speed), parseInt(data.previousData.max_speed), val => val === 0 ? 'N/A' : val, data.currentData.max_speed === 0 ? '' : 'km/h')}
                        {renderDataItem(parseDateMinutes(data.currentData.start_time), parseDateMinutes(data.previousData.start_time), () => data.currentData.start_time === 0 ? 'N/A' : formatDayTime(data.currentData.start_time))}
                    </div>
                    <div className='itemTop_data_container many_items'>
                        {renderDataItem(parseInt(data.previousData.max_speed), parseInt(data.currentData.max_speed), val => val === 0 ? 'N/A' : val, data.previousData.max_speed === 0 ? '' : 'km/h')}
                        {renderDataItem(parseDateMinutes(data.previousData.start_time), parseDateMinutes(data.currentData.start_time), () => data.previousData.start_time === 0 ? 'N/A' : formatDayTime(data.previousData.start_time))}
                    </div>
                </>
            )}

            {type === 'ralenti' && (
                <>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.currentIdle, data.previousIdle, formatTime)}
                    </div>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.previousIdle, data.currentIdle, formatTime)}
                    </div>
                </>
            )}

            {type === 'ralentiFuel' && (
                <>
                    <div className='itemTop_data_container many_items'>
                        {renderDataItem(data.currentFuelLost, data.previousFuelLost, val => val.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 'L')}
                        {renderDataItem(data.currentIdle, data.previousIdle, formatTime)}
                    </div>
                    <div className='itemTop_data_container many_items'>
                        {renderDataItem(data.previousFuelLost, data.currentFuelLost, val => val.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 'L')}
                        {renderDataItem(data.previousIdle, data.currentIdle, formatTime)}
                    </div>
                </>
            )}

            {type === 'fuel' && (
                <>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.currentConsumed, data.previousConsumed, val => val.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 'L')}
                    </div>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.previousConsumed, data.currentConsumed, val => val.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 'L')}
                    </div>
                </>
            )}

            {type === 'fuel_efficiency' && (
                <>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.currentEfficiency, data.previousEfficiency, val => val.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 'Km/L')}
                    </div>
                    <div className='itemTop_data_container'>
                        {renderDataItem(data.previousEfficiency, data.currentEfficiency, val => val.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 'Km/L')}
                    </div>
                </>
            )}

            {type === 'working_time' && (
                <>
                    <div className='itemTop_data_container many_items'>
                        {renderDataItem(parseDateMinutes(data.currentFromTrips), parseDateMinutes(data.previousFromTrips), () => data.currentFromTrips ? `${data.currentFromTrips.toLocaleTimeString('es-ES')} ${data.currentFromTrips.toLocaleDateString('es-ES')}` : 'Sin datos')}
                        {renderDataItem(parseDateMinutes(data.previousFromTrips), parseDateMinutes(data.currentFromTrips), () => data.previousFromTrips ? `${data.previousFromTrips.toLocaleTimeString('es-ES')} ${data.previousFromTrips.toLocaleDateString('es-ES')}` : 'Sin datos')}
                    </div>
                    <div className='itemTop_data_container many_items'>
                        {renderDataItem(parseDateMinutes(data.currentFromEvents), parseDateMinutes(data.previousFromEvents), () => data.currentFromEvents ? `${data.currentFromEvents.toLocaleTimeString('es-ES')} ${data.currentFromEvents.toLocaleDateString('es-ES')}` : 'Sin datos')}
                        {renderDataItem(parseDateMinutes(data.previousFromEvents), parseDateMinutes(data.currentFromEvents), () => data.previousFromEvents ? `${data.previousFromEvents.toLocaleTimeString('es-ES')} ${data.previousFromEvents.toLocaleDateString('es-ES')}` : 'Sin datos')}
                    </div>
                </>
            )}

            {type === 'out_time' && (
                <>
                    <div className='itemTop_data_container many_items'>
                        {renderDataItem(data.currentOnRangeTrips, data.previousOnRangeTrips, val => val)}
                        {renderDataItem(data.previousOnRangeTrips, data.currentOnRangeTrips, val => val)}
                    </div>
                    <div className='itemTop_data_container many_items'>
                        {renderDataItem(data.currentOnRangeEvents, data.previousOnRangeEvents, val => val)}
                        {renderDataItem(data.previousOnRangeEvents, data.currentOnRangeEvents, val => val)}
                    </div>
                </>
            )}
        </div>
    );
};

export default ItemList;
